export default {
  path: "/version",
  redirect: "/version/index",
  meta: {
    icon: "mdi:source-branch",
    showLink: true,
    title: "版本管理",
    rank: 10
  },
  children: [
    {
      path: "/version/software",
      name: "VersionSoftware",
      component: () => import("@/views/version/software/index.vue"),
      meta: {
        title: "软件集",
        showParent: true,
        icon: "ri:function-line"
      }
    },
    {
      path: "/version/firmware",
      name: "VersionFirmware",
      component: () => import("@/views/version/firmware/index.vue"),
      meta: {
        title: "固件集",
        showParent: true,
        icon: "ep:cpu"
      }
    },
    {
      path: "/version/file",
      name: "VersionFile",
      component: () => import("@/views/version/file/index.vue"),
      meta: {
        title: "文件集",
        showParent: true,
        icon: "ri:file-list-3-line"
      }
    }
  ]
} satisfies RouteConfigsTable;
